import React, { Component } from 'react';
import {loadStartupMenu} from '../../api/storefrontStartup';
import { Link } from 'react-router-dom';
import { slugify } from '../../utils/slug';
import BackToTop from '../utils/BackToTop';
import './FooterTheme.css';

const policies = [
    ['/privacypolicy', 'Privacy Policy'],
    ['/deliveryinfo', 'Shipping & Delivery'],
    ['/refundpolicy', 'Returns, Refunds & Cancellation'],
    ['/terms', 'Terms & Conditions'],
];
const helpLinks = [
    ['/aboutus', 'Our Story'], ['/contactus', 'Contact Us'],
    ['/account', 'My Account'], ['/orders', 'My Orders'],
    ['/trackorders', 'Track Your Order'], ['/wishlist', 'Your Wishlist'],
];

class Footer extends Component {
    state = { menu: [] };

    async componentDidMount() {
        this.isMountedFooter = true;
        try {
            const response = await loadStartupMenu();
            if (!this.isMountedFooter) return;
            if (response.status === 'success') this.setState({ menu: Array.isArray(response.data) ? response.data : [] });
        } catch (error) {
            console.error(error);
        }
        if (!this.isMountedFooter) return;
        const script = document.createElement('script');
        script.async = true;
        script.src = '/assets/js/main.js';
        document.body.appendChild(script);
    }

    componentWillUnmount() {
        this.isMountedFooter = false;
    }

    render() {
        return <>
            <footer className="nw-footer">
                <div className="nw-footer__intro">
                    <div className="container nw-footer__intro-inner">
                        <div><span className="nw-footer__eyebrow">Rooted in tradition</span>
                            <h2>Goodness that feels like home.</h2>
                            <p>Traditional oils, familiar ingredients, and everyday essentials for your family.</p>
                        </div>
                        <Link to="/aboutus" className="nw-footer__story">The Nature Way story <span aria-hidden="true">↗</span></Link>
                    </div>
                </div>
                <div className="container">
                    <div className="nw-footer__main">
                        <div className="nw-footer__brand">
                            <Link to="/" className="nw-footer__logo" aria-label="Nature Way home"><img src="/assets/img/logo.png" alt="Nature Way" loading="lazy" /></Link>
                            <p>From our roots to your kitchen.<br />Discover the taste of tradition with Nature Way.</p>
                            <div className="nw-footer__socials" aria-label="Follow Nature Way">
                                <a href="https://www.facebook.com/Naturewaymartoil" target="_blank" rel="noopener noreferrer" aria-label="Facebook"><i className="fa fa-facebook" aria-hidden="true" /></a>
                                <a href="https://www.instagram.com/natureway_oils/" target="_blank" rel="noopener noreferrer" aria-label="Instagram"><i className="fa fa-instagram" aria-hidden="true" /></a>
                                <a href="https://www.youtube.com/@naturewayagrofoodscosmetic3268" target="_blank" rel="noopener noreferrer" aria-label="YouTube"><i className="fa fa-youtube-play" aria-hidden="true" /></a>
                            </div>
                        </div>
                        <nav aria-label="Shop categories"><h3>Shop our range</h3><ul>
                            <li><Link to="/">Home</Link></li>
                            {this.state.menu.map((category, index) => {
                                const name = category.main_category_name || category.sub_category_name || category.name;
                                return name ? <li key={category.id || index}><Link to={`/category/${slugify(category.slug || name)}?scope=category`}>{name}</Link></li> : null;
                            })}
                        </ul></nav>
                        <nav aria-label="Customer help"><h3>Here to help</h3><ul>{helpLinks.map(([path, label]) => <li key={path}><Link to={path}>{label}</Link></li>)}</ul></nav>
                        <nav aria-label="Store policies"><h3>Our policies</h3><ul>{policies.map(([path, label]) => <li key={path}><Link to={path}>{label}</Link></li>)}</ul></nav>
                        <div className="nw-footer__contact"><h3>Let’s talk</h3><p>Have a question about your order or our products?</p>
                            <a href="tel:+918946025885"><i className="fa fa-phone" aria-hidden="true" /> +91 89460 25885</a>
                            <a href="mailto:info@natureway.in"><i className="fa fa-envelope-o" aria-hidden="true" /> info@natureway.in</a>
                            <Link className="nw-footer__contact-link" to="/contactus">Get in touch <span aria-hidden="true">↗</span></Link>
                        </div>
                    </div>
                    <div className="nw-footer__bottom"><p>© {new Date().getFullYear()} Nature Way. All rights reserved.</p><span>Tradition in every drop.</span></div>
                </div>
            </footer>
            <BackToTop />
            <div className="ps-preloader" id="preloader"><div className="ps-preloader-section ps-preloader-left" /><div className="ps-preloader-section ps-preloader-right" /></div>
        </>;
    }
}

export default Footer;
